const fr = {
  // Nav
  nav: {
    home: 'Accueil',
    menu: 'Carte',
    order: 'Commander',
    gallery: 'Galerie',
    reviews: 'Avis',
    reservation: 'Reservation',
    reserve: 'Reserver',
  },

  // Home page
  home: {
    sectionCuisine: 'Notre cuisine',
    sectionAtmosphere: 'Atmosphere',
    sectionFormules: 'Nos formules',
    sectionActus: 'Actualites',
    sectionSocial: 'Suivez-nous',
    sectionExceptions: 'Horaires exceptionnels',
    formulesSubtitle: 'Des prix qui font plaisir',
    actusSubtitle: 'Quoi de neuf ?',
    seeGallery: 'Voir la galerie photos',
    seeFullMenu: 'Decouvrir toute la carte',
    googleRating: '4,1/5 sur Google',
    googleRatingValue: '4,1',
    googleReviewsCount: '150 avis',
    formulesFrom: 'Formules dès 15 €',
    closed: 'Ferme',
    burgersCount: 'burgers au choix',
    callUs: 'Nous appeler',
    directions: 'Itineraire',

    // Fallback hero/about/atmosphere
    defaultHeroTitle: 'Votre restaurant de quartier a Bordeaux',
    defaultHeroSubtitle: 'Cuisine simple et genereuse, terrasse ombragee, ambiance conviviale.',
    defaultAboutTitle: 'Simple, frais et genereux',
    defaultAboutText: 'Chez Cote Terrasse, nous preparons une cuisine sincere a base de produits frais et de saison.',
    defaultAtmosphereTitle: 'Une terrasse cote jardin',
    defaultAtmosphereText: 'Profitez de notre salle cote jardin, un veritable havre de paix en plein Bordeaux.',
    defaultCtaTitle: 'Envie de venir ?',
    defaultCtaText: 'Reservez votre table en quelques clics ou passez nous voir directement.',
    defaultBtnReserve: 'Reserver une table',
    defaultBtnMenu: 'Voir la carte',
    defaultBtnCall: 'Nous appeler',
    defaultBtnDirections: 'Itineraire',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reservation & Contact',
    titleOnline: 'Reservez votre table',
    titlePhone: 'Reservez par telephone',
    phoneOnly: 'Reservation par telephone uniquement',
    phoneDesc: 'Pour reserver une table, appelez-nous directement. Notre equipe se fera un plaisir de vous accueillir.',
    callNow: 'Appeler maintenant',
    noPhone: 'Numero de telephone non renseigne. Contactez l\'administrateur.',
    formTitle: 'Demande de reservation',
    name: 'Nom',
    phone: 'Telephone',
    email: 'Email',
    date: 'Date',
    time: 'Heure',
    guests: 'Personnes',
    guestSingular: 'personne',
    guestPlural: 'personnes',
    message: 'Message (optionnel)',
    messagePlaceholder: 'Allergies, demandes speciales...',
    choose: 'Choisir',
    namePlaceholder: 'Votre nom',
    phonePlaceholder: '06 ...',
    emailPlaceholder: 'votre@email.com',
    submit: 'Envoyer la demande',
    sending: 'Envoi en cours...',
    success: 'Demande de reservation envoyee ! Nous vous contacterons bientot.',
    errorDate: 'Veuillez selectionner une date',
    errorTime: 'Veuillez selectionner une heure',
    errorGeneric: 'Erreur lors de l\'envoi. Veuillez reessayer.',
    infoTitle: 'Informations pratiques',
    openingHours: 'Horaires d\'ouverture',
    closed: 'Ferme',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Galerie',
    title: 'En images',
    description: 'Decouvrez notre terrasse, notre salle cote jardin et nos plats en photos.',
    all: 'Toutes',
    plats: 'Plats',
    terrasse: 'Terrasse',
    salle: 'Salle',
    ambiance: 'Ambiance',
    empty: 'Aucune photo dans cette categorie.',
    lightboxTitle: 'Photo de la galerie',
  },

  // Menu
  menu: {
    sectionLabel: 'Notre carte',
    title: 'La Carte',
    description: 'Decouvrez nos burgers maison, tapas a partager, et nos formules avantageuses. Cuisine preparee avec des produits frais et de saison.',
    formules: 'Formules',
    supplements: 'Supplements:',
    from: 'des',
    sides: 'Accompagnements',
    sidesIncluded: 'Compris dans le prix du burger:',
    sidesIncludedText: 'Frites fraiches ou Salade de saison.',
    sidesSupplements: 'Supplements:',
    sidesSupplementsText: 'Frites de Patate douce +3EUR | Bacon +3EUR | Cheddar +2EUR',
    sidesNote: 'Steack ANGUS 100% Pur Boeuf Origine France 150gr — Frites Fraiches cuites a la Belge au Blanc de Boeuf — Magret de Canard Sud-Ouest de France',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Avis clients',
    title: 'Ce qu\'ils en pensent',
    description: 'Majorite d\'avis 4 et 5 etoiles. Nos clients apprecient la qualite de notre cuisine, nos prix raisonnables et notre ambiance conviviale.',
    outOf: 'Sur plus de 200 avis',
  },

  // Legal
  legal: {
    title: 'Mentions legales',
    editor: 'Editeur du site',
    hosting: 'Hebergement',
    ip: 'Propriete intellectuelle',
    ipText: 'L\'ensemble du contenu de ce site (textes, images, logos, photos) est la propriete exclusive de Cote Terrasse, sauf mention contraire. Toute reproduction, meme partielle, est interdite sans autorisation prealable.',
    data: 'Donnees personnelles',
    dataText: 'Les informations collectees via le formulaire de reservation (nom, email, telephone) sont utilisees uniquement pour le traitement de votre demande de reservation. Conformement au RGPD, vous disposez d\'un droit d\'acces, de rectification et de suppression de vos donnees personnelles.',
    cookies: 'Cookies',
    cookiesText: 'Ce site utilise des cookies techniques necessaires a son bon fonctionnement. Aucun cookie publicitaire ou de suivi n\'est utilise.',
    privacy: 'Politique de confidentialite',
    privacyText: 'Nous nous engageons a proteger votre vie privee. Les donnees personnelles que vous nous communiquez ne sont jamais transmises a des tiers. Elles sont conservees pendant une duree maximale de 12 mois.',
    responsibility: 'Responsabilite',
    responsibilityText: 'Cote Terrasse s\'efforce de fournir des informations aussi precises que possible. Les prix et horaires affiches sont susceptibles de modifications sans preavis.',
    publishedBy: 'Directeur de la publication',
    phone: 'Telephone',
  },

  // Footer
  footer: {
    description: 'Restaurant convivial a Bordeaux. Cuisine de saison, burgers maison et une terrasse agreable cote jardin.',
    navigation: 'Navigation',
    contact: 'Contact',
    ourMenu: 'Notre Carte',
    customerReviews: 'Avis Clients',
    legalNotice: 'Mentions legales',
    legalAndPrivacy: 'Mentions legales & Politique de confidentialite',
    admin: 'Administration',
    copyright: 'Tous droits reserves.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'Nous revenons bientot',
    defaultMessage: 'Notre site est actuellement en cours de mise a jour. Merci de votre patience.',
    openingHours: 'Horaires d\'ouverture',
    closed: 'Ferme',
    copyright: 'Tous droits reserves.',
  },

  // Common
  common: {
    closed: 'Ferme',
    loading: 'Chargement...',
  },
};

export default fr;
